module.exports = __webpack_public_path__ + "img/logo-occasions-graph-exact.c2707421.svg";